import { ReactNode } from "react";
import { Grid } from "@mui/material";
import { StatItem } from "./StatItem";

export type Stat = {
  label: string;
  value: string;
  icon: ReactNode;
  onClick?: () => void;
};

export type StatsProps = {
  stats: Stat[];
  id?: string;
};

export function Stats({ stats, id }: StatsProps) {
  return (
    <Grid
      container
      id={id}
      className="asset-stats"
      columnSpacing={2}
      rowSpacing={1}
    >
      {stats.map((stat) => {
        return (
          <Grid key={stat.label}>
            <StatItem
              icon={stat.icon}
              value={stat.value}
              label={stat.label}
              onClick={stat.onClick}
            />
          </Grid>
        );
      })}
    </Grid>
  );
}
